import { AssetFileSpecification } from "./assetFileSpecification";

export class AssetFile {
    public _id: string;
    public filePath: string;
    public specification: AssetFileSpecification;
    public versionNo: string;
    public platform: string;
    public deleted: boolean;
    public previewBackgroudColor: string;
    public snapshotURL: Array<string>;
    public uploadedImageURL: Array<string>;
}